import { useTranslation } from "react-i18next";
import { SectionHeading } from "../../../../atom/SectionHeading";
import { StartingCard } from "./StartingCard";
import React from "react";
import { ParticipantExam } from "../../../../../types/components";
import { NoExams } from "../../../../molecules/exam/NoExams";
import { ROUTES } from "../../../../../utils/consts/routes";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../../../../../utils/contexts/UserProvider";
import { getResponsiblePersons } from "../../../../../utils/exam";

interface ExamSectionProps {
  startingExam?: [ParticipantExam] | null;
}

export const StartingExamSection: React.FC<ExamSectionProps> = ({ startingExam }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useUserContext();

  const id = startingExam?.[0]?.id;
  const is_completed = startingExam?.[0]?.is_completed;
  const exam = startingExam?.[0]?.exam;
  const code = exam?.code;
  const exam_type = exam?.exam_type;
  const questions_number = exam?.questions_number;
  const startDate = exam?.date_from ?? "";
  const endDate = exam?.date_to ?? "";
  const responsible_persons = exam?.responsible_persons;
  const authorizedPerson = getResponsiblePersons(responsible_persons);
  const is_finished = exam?.is_finished;
  const status = exam?.status;
  const secondsUntilStart = exam?.seconds_until_start ?? 0;
  const secondsUntilEnd = exam?.seconds_until_end ?? 0;

  return (
    <div className="flex flex-col gap-[40px] pb-[80px]">
      <SectionHeading
        title={t("Exams")}
        subtitle={t(
          "Stay prepared and on track with a quick glance at your upcoming exam. Check out All Exams for the full schedule.",
        )}
        subtitleClassName="max-w-[520px]"
        onClick={() => navigate(ROUTES.exams)}
        buttonText={t("View all exams")}
      />

      <div className="flex flex-col gap-[32px] mt-4">
        <p className="text-ominimo-400 uppercase font-semibold text-sm tracking-[1.5px] leading-[17.64px]">
          • {t("Upcoming")}
        </p>

        {exam && !user?.is_successfully_passed_exam ? (
          <StartingCard
            id={id}
            examId={exam?.id}
            title={code}
            type={exam_type?.name}
            questions={questions_number}
            authorizedPerson={authorizedPerson}
            startDate={startDate}
            is_completed={is_completed}
            is_finished={is_finished}
            endDate={endDate}
            examStatusCode={status?.code}
            secondsUntilStart={secondsUntilStart}
            secondsUntilEnd={secondsUntilEnd}
          />
        ) : (
          <div className="flex flex-col gap-2">
            {!user?.is_enrolled ? (
              <NoExams
                label={
                  <p className="text-[15px] leading-[18.9px]">
                    {t("You are not enrolled in any exams.")}{" "}
                    <span
                      className="text-ominimo-400 font-normal hover:cursor-pointer"
                      onClick={() => navigate(ROUTES.exams)}>
                      {t("Click here")}
                    </span>{" "}
                    {t("to view upcoming exams.")}
                  </p>
                }
              />
            ) : (
              <NoExams label="No upcoming exams." />
            )}
          </div>
        )}
      </div>
    </div>
  );
};
